/* eslint-disable */
import _ from 'lodash';
import { ReactComponent as LinkSvg } from 'images/schemas/link.svg';
import { ReactComponent as SingleLineTextSvg } from 'images/schemas/single_line_text.svg';
import { ReactComponent as LongTextSvg } from 'images/schemas/long_text.svg';
import { ReactComponent as AttachmentSvg } from 'images/schemas/attachment.svg';
import { ReactComponent as CheckboxSvg } from 'images/schemas/checkbox.svg';
import { ReactComponent as MultiSelectSvg } from 'images/schemas/multiple_select.svg';
import { ReactComponent as SingleSelectSvg } from 'images/schemas/single_select.svg';
import { ReactComponent as CollaboratorSvg } from 'images/schemas/collaborator.svg';
import { ReactComponent as DateSvg } from 'images/schemas/date.svg';
import { ReactComponent as PhoneNumberSvg } from 'images/schemas/phone_number.svg';
import { ReactComponent as EmailSvg } from 'images/schemas/email.svg';
import { ReactComponent as UrlSvg } from 'images/schemas/url.svg';
import { ReactComponent as NumberSvg } from 'images/schemas/number.svg';
import { ReactComponent as CurrencySvg } from 'images/schemas/currency.svg';
import { ReactComponent as PercentSvg } from 'images/schemas/percent.svg';
import { ReactComponent as DurationSvg } from 'images/schemas/duration.svg';
import { ReactComponent as RatingSvg } from 'images/schemas/rating.svg';
import { ReactComponent as FormulaSvg } from 'images/schemas/formula.svg';
import { ReactComponent as RollupSvg } from 'images/schemas/rollup.svg';
import { ReactComponent as CountSvg } from 'images/schemas/count.svg';
import { ReactComponent as LookupSvg } from 'images/schemas/lookup.svg';
import { ReactComponent as CreatedTimeSvg } from 'images/schemas/created_time.svg';
import { ReactComponent as LastTimeSvg } from 'images/schemas/last_modified_time.svg';
import { ReactComponent as AutoNumberSvg } from 'images/schemas/auto_number.svg';
import { ReactComponent as BarcodeSvg } from 'images/schemas/barcode.svg';
import { ReactComponent as ButtonSvg } from 'images/schemas/button.svg';
import { ReactComponent as CreatedBySvg } from 'images/schemas/created_by.svg';
import { ReactComponent as LastModifiedBySvg } from 'images/schemas/last_modified_by.svg';

export const SOURCE_API = 'api';
export const SOURCE_API2 = 'api2';
export const SOURCE_SCRIPT = 'script';
export const SOURCE_BLOCK = 'block';

export const PERMISSION_LEVELS = (source) => ({
  PL_CREATE: source === 'api' ? '' : 'create',
  PL_EDIT: source === 'api' ? '' : 'edit',
  PL_COMMENT: source === 'api' ? '' : 'comment',
  PL_READ: source === 'api' ? '' : 'read',
});

export const VIEW_TYPES = (source) => ({
  VT_GRID: source === 'api' ? '' : 'grid',
  VT_FORM: source === 'api' ? '' : 'form',
  VT_CALENDAR: source === 'api' ? '' : 'calendar',
  VT_GALLERY: source === 'api' ? '' : 'gallery',
  VT_KANBAN: source === 'api' ? '' : 'kanban',
});
export const FIELD_CONVERSIONS = {
  text: 'singleLineText',
  percentV2: 'percent',
  select: 'singleSelect',
  multiSelect: 'multipleSelects',
  collaborator: 'singleCollaborator',
  multiCollaborator: 'multipleCollaborators',
  foreignKey: 'multipleRecordLinks',
  phone: 'phoneNumber',
  multipleAttachment: 'multipleAttachments',
  lookup: 'multipleLookupValues',
};
export const FIELD_TYPES = (source) => ({
  SOURCE: source,
  FT_SINGLE_LINE: source === 'api' ? 'text' : 'singleLineText',
  FT_EMAIL: 'email',
  FT_URL: 'url',
  FT_MULTI_LINES: 'multilineText',
  FT_RICH_TEXT: 'richText',
  FT_NUMBER: 'number',
  FT_PERCENT: source === 'api' ? 'percentV2' : 'percent',
  FT_CURRENCY: 'currency',
  FT_SINGLE_SELECT: source === 'api' ? 'select' : 'singleSelect',
  FT_MULTI_SELECTS: source === 'api' ? 'multiSelect' : 'multipleSelects',
  FT_SINGLE_COLLAB: source === 'api' ? 'collaborator' : 'singleCollaborator',
  FT_MULTI_COLLABS: source === 'api' ? 'multiCollaborator' : 'multipleCollaborators',
  FT_RECORD_LINKS: source ==='api' ? 'foreignKey' : 'multipleRecordLinks',
  FT_DATE: 'date',
  FT_DATETIME: source === 'api' ? 'date' : 'dateTime',
  FT_PHONE: source === 'api' ? 'phone' : 'phoneNumber',
  FT_ATTACHMENTS: source === 'api' ? 'multipleAttachment' : 'multipleAttachments',
  FT_CHECKBOX: 'checkbox',
  FT_FORMULA: 'formula',
  FT_CREATED: 'createdTime',
  FT_ROLLUP: 'rollup',
  FT_COUNT: 'count',
  FT_LOOKUP: source === 'api' ? 'lookup' : 'multipleLookupValues',
  FT_AUTONUMBER: 'autoNumber',
  FT_BARCODE: 'barcode',
  FT_RATING: 'rating',
  FT_DURATION: 'duration',
  FT_LAST_MODIFIED: 'lastModifiedTime',
  FT_BUTTON: 'button',
  FT_CREATED_BY: 'createdBy',
  FT_LAST_MODIFIED_BY: 'lastModifiedBy',
  CUSTOM_LINKED_FIELD_DISPLAY: 'custom_linked_field_display',
  CUSTOM_TEXT: 'custom_text',
  CUSTOM_DIVIDER: 'custom_divider',
  CUSTOM_FORMULA: 'custom_formula',
  CUSTOM_GOOGLE_FILE: 'custom_google_file',
  CUSTOM_EMBED: 'custom_embed',
  CUSTOM_SPACER: 'custom_spacer',
  CUSTOM_GPT: 'custom_gpt'

});

export const FT_DETAILS = (source) => ({
  FT_SINGLE_LINE: {
    name: FIELD_TYPES(source).FT_SINGLE_LINE,
    type: 'string',
    typeLabel: 'Single Line Text',
    computed: false,
    array: false,
  },
  FT_EMAIL: {
    name: FIELD_TYPES(source).FT_EMAIL,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_URL: {
    name: FIELD_TYPES(source).FT_URL,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_MULTI_LINES: {
    name: FIELD_TYPES(source).FT_MULTI_LINES,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_RICH_TEXT: {
    name: FIELD_TYPES(source).FT_RICH_TEXT,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_NUMBER: {
    name: FIELD_TYPES(source).FT_NUMBER,
    type: 'number',
    computed: false,
    array: false,
  },
  FT_PERCENT: {
    name: FIELD_TYPES(source).FT_PERCENT,
    type: 'number',
    typeLabel: 'Percent',
    computed: false,
    array: false,
  },
  FT_CURRENCY: {
    name: FIELD_TYPES(source).FT_CURRENCY,
    type: 'number',
    computed: false,
    array: false,
  },
  FT_SINGLE_SELECT: {
    name: FIELD_TYPES(source).FT_SINGLE_SELECT,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_MULTI_SELECTS: {
    name: FIELD_TYPES(source).FT_MULTI_SELECTS,
    type: 'string',
    computed: false,
    array: true,
  },
  FT_SINGLE_COLLAB: {
    name: FIELD_TYPES(source).FT_SINGLE_COLLAB,
    type: 'object',
    computed: false,
    array: false,
  },
  FT_MULTI_COLLABS: {
    name: FIELD_TYPES(source).FT_MULTI_COLLABS,
    type: 'object',
    computed: false,
    array: true,
  },
  FT_RECORD_LINKS: {
    name: FIELD_TYPES(source).FT_RECORD_LINKS,
    type: 'string',
    typeLabel: 'Record Link',
    computed: false,
    array: true,
  },
  FT_DATE: {
    name: FIELD_TYPES(source).FT_DATE,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_DATETIME: {
    name: FIELD_TYPES(source).FT_DATETIME,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_PHONE: {
    name: FIELD_TYPES(source).FT_PHONE,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_ATTACHMENTS: {
    name: FIELD_TYPES(source).FT_ATTACHMENTS,
    type: 'object',
    computed: false,
    array: true,
  },
  FT_CHECKBOX: {
    name: FIELD_TYPES(source).FT_CHECKBOX,
    type: 'boolean',
    computed: false,
    array: false,
  },
  FT_FORMULA: {
    name: FIELD_TYPES(source).FT_FORMULA,
    type: 'any',
    computed: true,
    array: false,
  },
  FT_CREATED: {
    name: FIELD_TYPES(source).FT_CREATED,
    type: 'string',
    computed: true,
    array: false,
  },
  FT_ROLLUP: {
    name: FIELD_TYPES(source).FT_ROLLUP,
    type: 'any',
    computed: true,
    array: false,
  },
  FT_COUNT: {
    name: FIELD_TYPES(source).FT_COUNT,
    type: 'number',
    computed: true,
    array: false,
  },
  FT_LOOKUP: {
    name: FIELD_TYPES(source).FT_LOOKUP,
    type: 'any',
    computed: true,
    array: true,
  },
  FT_AUTONUMBER: {
    name: FIELD_TYPES(source).FT_AUTONUMBER,
    type: 'number',
    computed: true,
    array: false,
  },
  FT_BARCODE: {
    name: FIELD_TYPES(source).FT_BARCODE,
    type: 'string',
    computed: false,
    array: false,
  },
  FT_RATING: {
    name: FIELD_TYPES(source).FT_RATING,
    type: 'number',
    computed: false,
    array: false,
  },
  FT_DURATION: {
    name: FIELD_TYPES(source).FT_DURATION,
    type: 'number',
    computed: false,
    array: false,
  },
  FT_LAST_MODIFIED: {
    name: FIELD_TYPES(source).FT_LAST_MODIFIED,
    type: 'string',
    computed: true,
    array: false,
  },
  FT_BUTTON: {
    name: FIELD_TYPES(source).FT_BUTTON,
    type: 'object',
    computed: true,
    array: false,
  },
  FT_CREATED_BY: {
    name: FIELD_TYPES(source).FT_CREATED_BY,
    type: 'object',
    computed: true,
    array: false,
  },
  FT_LAST_MODIFIED_BY: {
    name: FIELD_TYPES(source).FT_LAST_MODIFIED_BY,
    type: 'object',
    computed: true,
    array: false,
  },
});

export function fieldsBy(source, mode, value, extract: boolean | string, list: any = null) {
  if (!list) list = FT_DETAILS(source);
  let fields = _.filter(list, (detail) => {
    return detail[mode] === value;
  });
  if (_.isString(extract)) {
    fields = _.map(fields, extract);
  }
  return fields;
}

export function fieldsName(source: string, name, extract: boolean | string = true) {
  return fieldsBy(source, 'name', name, extract);
}

export function fieldsType(source: string, type, extract: boolean | string = true) {
  return fieldsBy(source, 'type', type, extract);
}
export function fieldsEditable(source: string, extract: boolean | string = true) {
  fieldsComputed(source, false, extract);
}

export function fieldsComputed(source: string, computed = true, extract: boolean | string = true) {
  return fieldsBy(source, 'computed', computed, extract);
}
export function fieldsEditableNames(source: string) {
  return fieldsComputedNames(source, false);
}

export function fieldsComputedNames(source: string, computed = true) {
  return fieldsBy(source, 'computed', computed, 'name');
}

export function fieldsArray(source: string, array = true, extract: boolean | string = true) {
  return fieldsBy(source, 'array', array, extract);
}

export function fieldsArrayNames(source: string, array = true) {
  return fieldsBy(source, 'array', array, 'name');
}

export function isArrayType(source: string, type: string) {
  const types = fieldsArrayNames(source);
  return _.includes(types, type);
}

export function isComputedType(source: string, type: string) {
  const types = fieldsComputedNames(source);
  return _.includes(types, type);
}

export function isEditableType(source: string, type: string) {
  return !isComputedType(source, type);
}

export function pluckFieldsByType(source: string, type: string, fields: any[], extract: boolean | string = 'name') {
  return fieldsBy(source, 'type', type, extract, fields);
}
export function isType(source: string, type: string, types: string[] | string) {
  return _.includes(_.isArray(types) ? types : [types], type);
}

export function isTypeDate(source: string, type: string, allowFormulas = false) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_DATE, types.FT_DATETIME, allowFormulas ? types.FT_FORMULA : '']);
}
export function isTypeText(source: string, type: string, allowRich = true) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_SINGLE_LINE, types.FT_MULTI_LINES, allowRich ? types.FT_RICH_TEXT : '']);
}
export function isTypeLongText(source: string, type: string, allowRich = true) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_MULTI_LINES, allowRich ? types.FT_RICH_TEXT : '']);
}

export function isTypeRichText(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_RICH_TEXT]);
}

export function isTypeCollab(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_SINGLE_COLLAB, types.FT_MULTI_COLLABS]);
}
export function isTypeSelect(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_SINGLE_SELECT, types.FT_MULTI_SELECTS]);
}

export function isTypePercent(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_PERCENT, source === 'api' ? 'percent' : '']);
}
export function isTypeEmail(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_EMAIL]);
}
export function isTypeUrl(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_URL]);
}
export function isTypeNumber(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_NUMBER]);
}
export function isTypeNumeric(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [
    types.FT_NUMBER,
    types.FT_PERCENT,
    types.FT_CURRENCY,
    types.FT_AUTONUMBER,
    types.FT_COUNT,
    types.FT_RATING,
  ]);
}

export function isTypeCurrency(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_CURRENCY]);
}
export function isTypeRecordLink(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_RECORD_LINKS]);
}
export function isTypePhone(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_PHONE]);
}
export function isTypeAttachment(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_ATTACHMENTS]);
}
export function isTypeCheckbox(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_CHECKBOX]);
}
export function isTypeFormula(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_FORMULA]);
}
export function isTypeCreated(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_CREATED]);
}
export function isTypeRollup(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_ROLLUP]);
}
export function isTypeCount(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_COUNT]);
}
export function isTypeLookup(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_LOOKUP]);
}
export function isTypeAutonumber(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_AUTONUMBER]);
}
export function isTypeBarcode(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_BARCODE]);
}
export function isTypeRating(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_RATING]);
}
export function isTypeDuration(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_DURATION]);
}
export function isTypeLastModfied(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_LAST_MODIFIED]);
}

export function isTypeCaseSensitive(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [
    types.FT_SINGLE_LINE,
    types.FT_MULTI_LINES,
    types.FT_RICH_TEXT,
    types.FT_LOOKUP,
    types.FT_ROLLUP,
    types.FT_FORMULA,
    types.FT_RECORD_LINKS,
    types.FT_EMAIL,
    types.FT_MULTI_SELECTS,
    types.FT_SINGLE_SELECT,
    types.FT_MULTI_COLLABS,
    types.FT_SINGLE_COLLAB,
    types.FT_URL,
  ]);
}

export function isTypeButton(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_BUTTON]);
}
export function isTypeCreatedB(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_CREATED_BY]);
}
export function isTypeLastModifiedBy(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [types.FT_LAST_MODIFIED_BY]);
}

export function typeLabel(source: string, type: string) {
  const [details = null] = fieldsName(source, type);
  if (details && details['typeLabel']) return details['typeLabel'];
  return _.startCase(type);
}

export function fieldTypeLabels(source: string) {
  const types = FIELD_TYPES(source);
  const labels = {};
  _.each(types, (type) => (labels[type] = typeLabel(source, type)));
  return labels;
}

export function isTypeArray(source: string, type: string) {
  const types = FIELD_TYPES(source);
  return isType(source, type, [
    types.FT_MULTI_COLLABS,
    types.FT_SINGLE_COLLAB,
    types.FT_LOOKUP,
    types.FT_MULTI_SELECTS,
    types.FT_ATTACHMENTS,
    types.FT_RECORD_LINKS,
  ]);
}



/* eslint-enable */
